import classNames from 'classnames/bind';
import styles from './ServiceSpa.module.scss';

const cx = classNames.bind(styles);

function ServiceSpaItem({ title, image, backgroundColor, content }) {
    return (
        <div
            className={cx('service-item-wrapper')}
            style={{
                backgroundColor,
            }}
        >
            <img src={image} alt="" className={cx('image')} />
            <p className={cx('title')}>{title}</p>
            <p className={cx('content')}>{content}</p>
        </div>
    );
}

export default ServiceSpaItem;
